module.exports = __webpack_public_path__ + "img/hotel14.02b7e28e.png";